import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import {memo} from 'react';
import {CONTAINER_FULL_WIDTH_MAX, CONTAINER_XL_MIN, maxWidth, maxWidthQuery} from '@/styles/breakpoints';

// Up to 1450px the container runs the full viewport width, keeping only the standard
// gutter so content still clears the screen edges. Without this the `lg` cap (1200px)
// leaves a dead margin on both sides — e.g. roughly 120px of centring on a 1440px screen.
// Above 1450px the `xl` cap takes over.
const fullWidthBandSx = {
    [maxWidth(CONTAINER_FULL_WIDTH_MAX)]: {
        maxWidth: '100% !important'
    }
} as const;

const XL_QUERY = maxWidthQuery(CONTAINER_XL_MIN);

const MUIContainer = (props: any): any => {
    const smallScreen = useMediaQuery(XL_QUERY);
    const {children, className, sx} = props;
    // `sx` is normalised to an array so the band rule always applies and any caller-supplied
    // styles still win by coming later. A missing `sx` contributes nothing.
    const sxList = Array.isArray(sx) ? sx : [sx];
    return (
        <Container className={className} maxWidth={smallScreen ? 'lg' : 'xl'} sx={[fullWidthBandSx, ...sxList.filter(Boolean)]}>
            {children}
        </Container>
    );
};

export default memo(MUIContainer);
